import type { FC } from "react";

import { LoadingScreen } from "../LoadingScreen/LoadingScreen";
import { BasePage } from "../BasePage/BasePage";

/**
 * LoadingPage component.
 */
export const LoadingPage: FC = () => {
  return (
    <BasePage variant="marketing">
      <LoadingScreen />
    </BasePage>
  );
};
